import clsx from 'clsx';
import { doneLabel, stageLabel } from '@doit/shared';
import type { StageAssessment, StageCert } from '../api/types';

/** ყველა ეტაპი რიგით: ისტორია (I ...) და ბოლოს მიმდინარე */
function stagesOf(a: StageAssessment): StageCert[] {
  return [...a.previous, a];
}

/** ეტაპის წარწერა — მხოლოდ მაშინ, როცა ეტაპი ერთზე მეტია */
function StageTag({ stage, show }: { stage: number; show: boolean }) {
  if (!show) return null;
  return <span className="mr-1.5 text-[11px] text-ink-mute">{stageLabel(stage)}:</span>;
}

/** სიის სვეტი: რა არის შესრულებული — ეტაპების მიხედვით */
export function DoneCell({ assessment }: { assessment: StageAssessment | null | undefined }) {
  if (!assessment) return <span className="text-ink-mute">—</span>;
  const stages = stagesOf(assessment);
  return (
    <span className="flex flex-col gap-0.5">
      {stages.map((s) => {
        const label = doneLabel(s);
        return (
          <span key={s.stage} className="whitespace-nowrap">
            <StageTag stage={s.stage} show={stages.length > 1} />
            <span className={label === '—' ? 'text-ink-mute' : 'text-ink'}>{label}</span>
          </span>
        );
      })}
    </span>
  );
}

/** სიის სვეტი: რა ეწერება სერტიფიკატზე — ეტაპების მიხედვით, მოკლედ */
export function CertBadge({ assessment }: { assessment: StageAssessment | null | undefined }) {
  if (!assessment) return <span className="text-ink-mute">—</span>;
  const stages = stagesOf(assessment);
  return (
    <span className="flex flex-col gap-1">
      {stages.map((s) => (
        <span key={s.stage} className="whitespace-nowrap">
          <StageTag stage={s.stage} show={stages.length > 1} />
          <CertPill cert={s.cert} />
        </span>
      ))}
    </span>
  );
}

/** ერთი სტატუსი; შეუფასებელი ეტაპი — ტირე */
export function CertPill({ cert }: { cert: StageCert['cert'] }) {
  if (!cert) return <span className="text-ink-mute">—</span>;
  return (
    <span
      title={cert.manual ? 'მენეჯერის მიერ ხელით არჩეული' : undefined}
      className={clsx(
        'inline-block whitespace-nowrap rounded px-2 py-0.5 text-[11px] font-medium',
        cert.kind === 'INTERNATIONAL'
          ? 'bg-brand-600 text-white'
          : cert.kind === 'NONE'
            ? 'bg-canvas text-ink-mute'
            : 'bg-brand-100 text-brand-700',
      )}
    >
      {cert.text}
    </span>
  );
}
